import { ICsvImportTemplateProps } from '@/imports/ui/components/csv/CsvImportTemplate';

enum CompanyCsvHeaders {
  ID = 'Id',
  NAME = 'Organization Name',
  EMAIL = 'Email',
  ADDRESS = 'Address',
  CITY = 'City',
  COUNTRY = 'Country',
  POSTAL_CODE = 'Postal Code',
  STATE = 'State',
  PHONE_NUMBER = 'Phone Number',
  WEBSITE = 'Website',
  IS_SPONSOR = 'Is Sponsor',
  MEMBER_STATUS = 'Member Status',
  HIDDEN = 'Hidden',
  HIDE_FROM_MEMBER_DIRECTORY = 'Hide From Member Directory',
  PRIVATE_COMMUNITY_PROFILE = 'Private Community Profile',
  MEMBERSHIP_TYPE = 'Membership Type',
  MEMBERSHIP_TERM_START_DATE = 'Membership Term Start Date (MM/DD/YYYY)',
  MEMBERSHIP_TERM_END_DATE = 'Membership Term End Date (MM/DD/YYYY)',
  PAYMENT_DUE = 'Payment Due',
}

type COMPANY_HEADERS_IMPORT_NON_MM =
  | CompanyCsvHeaders.ID
  | CompanyCsvHeaders.NAME
  | CompanyCsvHeaders.EMAIL
  | CompanyCsvHeaders.ADDRESS
  | CompanyCsvHeaders.CITY
  | CompanyCsvHeaders.COUNTRY
  | CompanyCsvHeaders.POSTAL_CODE
  | CompanyCsvHeaders.STATE
  | CompanyCsvHeaders.PHONE_NUMBER
  | CompanyCsvHeaders.WEBSITE
  | CompanyCsvHeaders.IS_SPONSOR
  | CompanyCsvHeaders.MEMBER_STATUS
  | CompanyCsvHeaders.HIDDEN
  | CompanyCsvHeaders.HIDE_FROM_MEMBER_DIRECTORY
  | CompanyCsvHeaders.PRIVATE_COMMUNITY_PROFILE;

type COMPANY_HEADERS_IMPORT_MM =
  | CompanyCsvHeaders.ID
  | CompanyCsvHeaders.NAME
  | CompanyCsvHeaders.EMAIL
  | CompanyCsvHeaders.ADDRESS
  | CompanyCsvHeaders.CITY
  | CompanyCsvHeaders.COUNTRY
  | CompanyCsvHeaders.POSTAL_CODE
  | CompanyCsvHeaders.STATE
  | CompanyCsvHeaders.PHONE_NUMBER
  | CompanyCsvHeaders.WEBSITE
  | CompanyCsvHeaders.IS_SPONSOR
  | CompanyCsvHeaders.HIDDEN
  | CompanyCsvHeaders.HIDE_FROM_MEMBER_DIRECTORY
  | CompanyCsvHeaders.PRIVATE_COMMUNITY_PROFILE
  | CompanyCsvHeaders.MEMBERSHIP_TYPE
  | CompanyCsvHeaders.MEMBERSHIP_TERM_START_DATE
  | CompanyCsvHeaders.MEMBERSHIP_TERM_END_DATE
  | CompanyCsvHeaders.PAYMENT_DUE;

export const REQUIRED_COMPANY_HEADERS_FOR_INSERT = [CompanyCsvHeaders.NAME];

export const FOREIGN_KEY_OPTIONS: {
  value: string;
  label: CompanyCsvHeaders;
}[] = [
  {
    value: '_id',
    label: CompanyCsvHeaders.ID,
  },
  {
    value: 'name',
    label: CompanyCsvHeaders.NAME,
  },
];

const NON_MEMBER_MANAGEMENT_COMPANY_UPLOAD_TEMPLATE: ICsvImportTemplateProps<
  Record<COMPANY_HEADERS_IMPORT_NON_MM, string>
> = {
  filename: 'Organization_template.csv',
  rows: [
    {
      [CompanyCsvHeaders.ID]: 'xyz1',
      [CompanyCsvHeaders.NAME]: 'Apple',
      [CompanyCsvHeaders.EMAIL]: 'example@apple.com',
      [CompanyCsvHeaders.ADDRESS]: '1 Infinite Loop',
      [CompanyCsvHeaders.CITY]: 'Cupertino',
      [CompanyCsvHeaders.COUNTRY]: 'US',
      [CompanyCsvHeaders.POSTAL_CODE]: '95014',
      [CompanyCsvHeaders.STATE]: 'CA',
      [CompanyCsvHeaders.PHONE_NUMBER]: '1234567890',
      [CompanyCsvHeaders.WEBSITE]: 'apple.com',
      [CompanyCsvHeaders.IS_SPONSOR]: 'TRUE',
      [CompanyCsvHeaders.MEMBER_STATUS]: 'Not a Member',
      [CompanyCsvHeaders.HIDDEN]: 'FALSE',
      [CompanyCsvHeaders.HIDE_FROM_MEMBER_DIRECTORY]: 'FALSE',
      [CompanyCsvHeaders.PRIVATE_COMMUNITY_PROFILE]: 'FALSE',
    },
    {
      [CompanyCsvHeaders.ID]: 'xyz2',
      [CompanyCsvHeaders.NAME]: 'Google',
      [CompanyCsvHeaders.EMAIL]: 'example@google.com',
      [CompanyCsvHeaders.ADDRESS]: '1600 Amphitheatre Pkwy',
      [CompanyCsvHeaders.CITY]: 'Mountain View',
      [CompanyCsvHeaders.COUNTRY]: '',
      [CompanyCsvHeaders.POSTAL_CODE]: '',
      [CompanyCsvHeaders.STATE]: '',
      [CompanyCsvHeaders.PHONE_NUMBER]: '',
      [CompanyCsvHeaders.WEBSITE]: 'google.com',
      [CompanyCsvHeaders.IS_SPONSOR]: 'FALSE',
      [CompanyCsvHeaders.MEMBER_STATUS]: 'Member',
      [CompanyCsvHeaders.HIDDEN]: '',
      [CompanyCsvHeaders.HIDE_FROM_MEMBER_DIRECTORY]: '',
      [CompanyCsvHeaders.PRIVATE_COMMUNITY_PROFILE]: '',
    },
  ],
};

const MEMBER_MANAGEMENT_COMPANY_UPLOAD_TEMPLATE: ICsvImportTemplateProps<
  Record<COMPANY_HEADERS_IMPORT_MM, string>
> = {
  filename: 'Organization_template.csv',
  rows: [
    {
      [CompanyCsvHeaders.ID]: 'xyz1',
      [CompanyCsvHeaders.NAME]: 'Apple',
      [CompanyCsvHeaders.EMAIL]: 'example@apple.com',
      [CompanyCsvHeaders.ADDRESS]: '1 Inf Loop',
      [CompanyCsvHeaders.CITY]: 'Cupertino',
      [CompanyCsvHeaders.COUNTRY]: 'US',
      [CompanyCsvHeaders.POSTAL_CODE]: '17101',
      [CompanyCsvHeaders.STATE]: 'PA',
      [CompanyCsvHeaders.PHONE_NUMBER]: '0123456789',
      [CompanyCsvHeaders.WEBSITE]: 'apple.com',
      [CompanyCsvHeaders.IS_SPONSOR]: 'TRUE',
      [CompanyCsvHeaders.HIDDEN]: 'FALSE',
      [CompanyCsvHeaders.HIDE_FROM_MEMBER_DIRECTORY]: 'FALSE',
      [CompanyCsvHeaders.PRIVATE_COMMUNITY_PROFILE]: 'FALSE',
      [CompanyCsvHeaders.MEMBERSHIP_TYPE]: 'Student Membership',
      [CompanyCsvHeaders.MEMBERSHIP_TERM_START_DATE]: '03/24/2022',
      [CompanyCsvHeaders.MEMBERSHIP_TERM_END_DATE]: '11/28/2024',
      [CompanyCsvHeaders.PAYMENT_DUE]: 'No',
    },
    {
      [CompanyCsvHeaders.ID]: 'xyz2',
      [CompanyCsvHeaders.NAME]: 'Google',
      [CompanyCsvHeaders.EMAIL]: 'example@google.com',
      [CompanyCsvHeaders.ADDRESS]: '33 Gi Rd',
      [CompanyCsvHeaders.CITY]: 'Mountain View',
      [CompanyCsvHeaders.COUNTRY]: '',
      [CompanyCsvHeaders.POSTAL_CODE]: '',
      [CompanyCsvHeaders.STATE]: '',
      [CompanyCsvHeaders.PHONE_NUMBER]: '',
      [CompanyCsvHeaders.WEBSITE]: 'google.com',
      [CompanyCsvHeaders.IS_SPONSOR]: 'FALSE',
      [CompanyCsvHeaders.HIDDEN]: '',
      [CompanyCsvHeaders.HIDE_FROM_MEMBER_DIRECTORY]: '',
      [CompanyCsvHeaders.PRIVATE_COMMUNITY_PROFILE]: '',
      [CompanyCsvHeaders.MEMBERSHIP_TYPE]: 'Cheapo Membership',
      [CompanyCsvHeaders.MEMBERSHIP_TERM_START_DATE]: '04/28/2023',
      [CompanyCsvHeaders.MEMBERSHIP_TERM_END_DATE]: '12/1/2024',
      [CompanyCsvHeaders.PAYMENT_DUE]: '',
    },
  ],
};

export const getCompanyUploadTemplate = (
  memberManagementEnabled: boolean
): ICsvImportTemplateProps<Record<COMPANY_HEADERS_IMPORT_MM, string>> => {
  return memberManagementEnabled
    ? MEMBER_MANAGEMENT_COMPANY_UPLOAD_TEMPLATE
    : NON_MEMBER_MANAGEMENT_COMPANY_UPLOAD_TEMPLATE;
};
